import {
  FormControl,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useLoad } from "../../context";
import ApiServices from "../../services/apiServices";
import storage from "../../services/storage";
import "./index.css";
import { Link } from "react-router-dom";
import IcoEditar from "../../assets/images/svgs/IcoEditar.svg";

export default function Pesquisa() {
  const [totalPagePesquisa, setTotalPagePesquisa] = useState(1);
  const [pagePesquisa, setPagePesquisa] = useState(1);
  const [pesquisa, setPesquisa] = useState("");
  const [listaPesquisa, setListaPesquisa] = useState([]);
  const [verMais, setVerMais] = useState(0);
  const [itensPorPagina, setItensPorPagina] = useState(5);
  const { load, setLoad } = useLoad();

  async function fnPesquisaCarregar() {
    setLoad(true);

    try {
      setLoad(true);
      let response = await ApiServices.apiGet(
        `pesquisa/pesquisa-usuario?&q=${pesquisa}`
      );
      setTotalPagePesquisa(response.data.totalPages);
      setListaPesquisa(response.data.items);
      setVerMais(itensPorPagina);

      toast.error(response.statusCode != 200 && response.message);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  useEffect(() => {
    fnPesquisaCarregar();
  }, []);
  useEffect(() => {
    fnPesquisaCarregar(pesquisa);
  }, [pesquisa]);

  return (
    <>
      <div className="container">
        <h2 className="mt-5 mb-5">Pesquisa</h2>
        <div
          className="row"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <div className="col-md-3 p-0 mb-5 d-flex align-items-center campo-busca-pesquisa">
            <input
              type="text"
              placeholder="O que você procura na Leo?"
              onChange={(e) => {
                setPesquisa(e.target.value);
              }}
              className="form-control"
              value={pesquisa}
            />
          </div>
        </div>
        <table className="tablePesquisa">
          <thead>
            <tr>
              <th className="pesquisaCabecalho">Titulo</th>
              <th className="pesquisaCabecalho">De</th>
              <th className="pesquisaCabecalho">Até</th>
              <th className="pesquisaCabecalho">Status</th>
              <th className="pesquisaCabecalho">Resposta Enviada</th>
              <th className="pesquisaCabecalho"></th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(listaPesquisa) &&
              listaPesquisa.slice(0, verMais).map((item, i) => (
                <tr key={i}>
                  <td className="pesquisaLinha">{item?.titulo}</td>
                  <td className="pesquisaLinha">
                    {moment(item?.dataInicio).format("DD/MM/YYYY")}
                  </td>
                  <td className="pesquisaLinha">
                    {moment(item?.dataFim).format("DD/MM/YYYY")}
                  </td>
                  <td className="pesquisaLinha">
                    {item?.status === "EmAndamento"
                      ? "Em Andamento"
                      : item?.status}
                  </td>
                  <td className="pesquisaLinha">
                    {item?.usuarioJaRespondeu ? "Sim" : "Não"}
                  </td>
                  <td className="pesquisaLinha">
                    <Link to={`/pesquisa/${item?.pesquisaId}`}>
                      <img src={IcoEditar} alt="Editar" />
                    </Link>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        <div className="d-flex justify-content-center">
          {verMais < listaPesquisa?.length && (
            <button
              onClick={() => {
                setVerMais(verMais + itensPorPagina);
              }}
              className="btn btn-warning btn-lg"
              style={{ maxWidth: 200, margin: 20 }}
            >
              Ver Mais
            </button>
          )}
        </div>
      </div>
    </>
  );
}
